// Records signed-in member page views and a light heartbeat for the admin "Online now" panel.
import { useEffect, useRef } from "react";
import { useRouterState } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth-context";
import { supabase } from "@/integrations/supabase/client";

function sessionId() {
  try {
    let id = sessionStorage.getItem("xau_presence_sid");
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem("xau_presence_sid", id);
    }
    return id;
  } catch {
    return "nosession";
  }
}

export function PresenceTracker() {
  const { user } = useAuth();
  const path = useRouterState({ select: (s) => s.location.pathname });
  const pathRef = useRef(path);
  pathRef.current = path;

  // The query builder is lazy: the request only fires once .then() is called.
  const record = (userId: string, p: string, heartbeat: boolean) =>
    supabase
      .from("member_page_views")
      .insert({ user_id: userId, session_id: sessionId(), path: p.slice(0, 300), heartbeat })
      .then(({ error }) => {
        if (error) console.warn("presence insert failed", error.message);
      });

  useEffect(() => {
    if (!user) return;
    record(user.id, path, false);
  }, [user?.id, path]);

  useEffect(() => {
    if (!user) return;
    const t = setInterval(() => {
      if (document.visibilityState !== "visible") return;
      record(user.id, pathRef.current, true);
    }, 60_000);
    return () => clearInterval(t);
  }, [user?.id]);

  return null;
}
